import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash-es';
import * as PropTypes from 'prop-types';

import { getVideoBoxUISelector } from './selectors';

import { ContentBox } from '../content-box';
import { RelatedVideosDecorated } from './related-videos';
import { VideoBoxError } from './fragments/video-box-error';
import { VideoPlayerDecorated } from 'components/video-player';
import { VideoTabsDecorated } from './video-tabs';
import { videoBoxResetAction } from './actions';
import { viewRangeSelector } from 'common/selectors/integration';
import { VideoBoxButtonsDecorated } from './video-buttons';
import { RESPONSIVE_RANGES } from 'utils/enums';

class VideoBox extends React.Component {
  componentDidMount() {
    this.props.requestVideo(this.props.videoBoxRequestAction);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      get(prevProps, 'videoBoxRequestAction.payload.videoId') !==
      get(this.props, 'videoBoxRequestAction.payload.videoId')
    ) {
      this.props.requestVideo(this.props.videoBoxRequestAction);
    }
  }

  componentWillUnmount() {
    this.props.resetVideo();
  }

  render() {
    const { error, playerConfiguration, inlineVideoControls, withRelatedVideos = false, isMobile } = this.props;

    return error ? (
      <VideoBoxError />
    ) : (
      <ContentBox>
        <div className="ct-video-box__container">
          <div className="ct-video-box__video" data-e2e="ct-video-box">
            <VideoPlayerDecorated playerConfiguration={playerConfiguration} inlineVideoControls={inlineVideoControls} />
          </div>
          {withRelatedVideos && (
            <div className="ct-video-box__related-videos">
              <RelatedVideosDecorated />
            </div>
          )}
        </div>
        {isMobile ? <VideoBoxButtonsDecorated /> : <VideoTabsDecorated />}
      </ContentBox>
    );
  }
}

const mapStateToProps = (state) => {
  const range = viewRangeSelector(state);
  const isMobile = range === RESPONSIVE_RANGES.MOBILE_SMALL || range === RESPONSIVE_RANGES.MOBILE_LARGE;

  return {
    error: getVideoBoxUISelector(state).error,
    isMobile,
  };
};

const mapDispatchToProps = (dispatch) => ({
  requestVideo: (action) => action && dispatch(action),
  resetVideo: () => dispatch(videoBoxResetAction()),
});

export const VideoBoxDecorated = connect(mapStateToProps, mapDispatchToProps)(VideoBox);

VideoBoxDecorated.propTypes = {
  playerConfiguration: PropTypes.object,
  withRelatedVideos: PropTypes.bool,
  inlineVideoControls: PropTypes.func,
};

export * from './common/pin-unpin-video';
export * from './common/download-video';
